import { useContext } from 'react';
import { Stack } from '@mantine/core';
import { i18n } from '@lingui/core';
import { ProfileContext } from '../../Service/Context/ProfileContext';
import PanePaper from '../PanePaper';
import BookitupTextInput from '../../Atoms/inputs/BookitupTextInput';

const WebPresentationSettings = () => {
  const { profile, patchProfile } = useContext(ProfileContext);
  const { addressOfWebsite, addressOfFacebook, addressOfInstagram } = profile;

  return (
    <PanePaper title="common.settings.websites">
      <Stack spacing="xs">
        <BookitupTextInput
          label={i18n._('applicationuser.website')}
          defaultValue={addressOfWebsite}
          onBlurSave={(val) => patchProfile({ addressOfWebsite: val })}
        />

        <BookitupTextInput
          label={i18n._('applicationuser.facebook')}
          defaultValue={addressOfFacebook}
          onBlurSave={(val) => patchProfile({ addressOfFacebook: val })}
        />

        <BookitupTextInput
          label={i18n._('applicationuser.instagram')}
          defaultValue={addressOfInstagram}
          onBlurSave={(val) => patchProfile({ addressOfInstagram: val })}
        />
      </Stack>
    </PanePaper>
  );
};

export default WebPresentationSettings;
